/* eslint-disable import/prefer-default-export,prefer-template,no-useless-escape */

/**
 * Redirect 404 to equivalent site.
 */
export const handle404 = () => {
    let newUrl = "https://my.marketaxess.com";
    newUrl = newUrl.concat(window.location.pathname, window.location.search, window.location.hash);
    window.location.href = newUrl;
};

/**
 * Get Query Param by Name
 * 
 * @param nameString
 * @param urlString
 * @return {*}
 */
export const getParameterByName = (nameString, urlString) => {
    const url = !urlString ? window.location.href : urlString;
    const name = nameString.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};



// WEBPACK FOOTER //
// ./frontend/helpers/url.js